export default __webpack_public_path__ + "static/media/ic_plus_dark.a06571ba.svg";